export function extractFileNameFromUrl(url: string) {
  return decodeURIComponent(url.split('/').pop() || '')
}
